import reset from "./reset";

const middlewares = [reset];

const getMiddlewaresArray =
  (middlewares: any) =>
  (slices = {}) => {
    return middlewares.map((middleware: any) => {
      return middleware(slices);
    });
  };

export default getMiddlewaresArray(middlewares);
